var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-app-bar",
        { attrs: { app: "", color: "header" } },
        [
          _c("v-spacer"),
          _vm.app.room &&
          _vm.app.room.settings &&
          !["", null, "test"].includes(_vm.app.room.settings.header_logo)
            ? _c("v-img", {
                attrs: {
                  src: _vm.app.room.settings.header_logo,
                  "max-height": "40",
                  contain: "",
                  position: "center",
                },
              })
            : _vm.app.site &&
              _vm.app.site.domain_settings &&
              _vm.app.site.domain_settings.settings.header_logo &&
              !["", null, "test"].includes(
                _vm.app.site.domain_settings.settings.header_logo
              )
            ? _c("v-img", {
                attrs: {
                  src: _vm.app.site.domain_settings.settings.header_logo,
                  "max-height": "40",
                  contain: "",
                  position: "center",
                },
              })
            : _vm.app.room
            ? _c(
                "div",
                {
                  staticClass: "text-h5 font-weight-bold primary--text",
                  staticStyle: { "text-align": "center", width: "100%" },
                },
                [_vm._v(_vm._s(_vm.app.room.post_title))]
              )
            : _c(
                "div",
                {
                  staticClass: "text-h5 font-weight-bold primary--text",
                  staticStyle: { "text-align": "center", width: "100%" },
                },
                [_vm._v("VIPHuddles.com")]
              ),
          _c("v-spacer"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }